import * as actions from 'redux/actions/competitors.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import { hasPropertyChain } from 'helpers/util'

const initialState = {
  competitors: {},
  overview: null
}

const initialCompetitorState = {
  history: null
}

const getCompetitorsWithNewCompetitor = (competitors, newKeywordId) => {
  return Object.assign({}, competitors, {
    [newKeywordId]: {
      ...initialCompetitorState
    }
  })
}

const updateCompetitor = (competitor, { type, payload = {} }) => {
  switch (type) {
    case actions.getCompetitorHistorySuccess.type:
      return {
        ...competitor,
        history: payload.data
      }
    default:
      return {
        ...competitor
      }
  }
}

const updateCompetitors = (competitors, { type, payload = {} }) => {
  let updatedCompetitors = {
    ...competitors
  }
  switch (type) {
    case actions.getCompetitorHistorySuccess.type:
      updatedCompetitors[payload.keywordId] = updateCompetitor(
        updatedCompetitors[payload.keywordId],
        { type, payload }
      )
      return updatedCompetitors
    default:
      return updatedCompetitors
  }
}

const competitorsReducer = (state = initialState, { type, payload = {} }) => {
  let competitors = state.competitors

  switch (type) {
    case actions.getCompetitorHistorySuccess.type:
      // create domain object if missing in domains
      if (!hasPropertyChain(competitors, payload.competitorId)) {
        competitors = getCompetitorsWithNewCompetitor(competitors, payload.keywordId)
      }
      return {
        ...state,
        competitors: updateCompetitors(competitors, { type, payload })
      }
    case actions.loadCompetitorOverviewSuccess.type:
      return {
        ...state,
        overview: payload.data
      }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}

export default competitorsReducer
